import React from "react";
import Spacing from "../_shared/Spacing";
import Switcher from "./Switcher";
import HighLights from "./HighLights";
import Additions from "./Additions";
import s from "./Tabs.module.css";
import TabsFancyTitle from "./TabsFancyTitle";
import Container from "../../../Container";
import { Mobile, Desktop } from "../_shared/Bp";
import FancyLink from "../_shared/FancyLink";

function Tab({ highlights, additions }) {
  return (
    <React.Fragment>
      <HighLights data={highlights} />
      <Additions data={additions} />
    </React.Fragment>
  );
}

function DesktopTabs({ tabs, spacing }) {
  const [active, setActive] = React.useState(tabs[0]?.id);
  const activeTab = tabs.find((t) => t.id === active);

  return (
    <Spacing value={spacing}>
      <Container>
        <div className={s.tabs}>
          <div>
            <TabsFancyTitle title="Invisible" invisible />
            <Switcher tabs={tabs} active={active} setActive={setActive} />
          </div>
          <div className={s.content}>
            <Tab {...activeTab} />
          </div>
          {/* The footer comes here... */}
        </div>
      </Container>
    </Spacing>
  );
}

function MobileTabs({ tabs, mobile_links }) {
  const [active, setActive] = React.useState(null);
  const activeTab = tabs.find((t) => t.id === active);

  return (
    <div className={s.tabs}>
      <Switcher
        links={mobile_links}
        tabs={tabs}
        active={active}
        setActive={(newId) => {
          if (newId === active) {
            setActive(null);
          } else {
            setActive(newId);
          }
        }}
      >
        <div className={s.content}>
          <Tab {...activeTab} />
        </div>
      </Switcher>
    </div>
  );
}

function Tabs(props) {
  return (
    <React.Fragment>
      <Desktop>
        <DesktopTabs {...props} />
      </Desktop>

      <Mobile>
        <MobileTabs {...props} />
      </Mobile>
    </React.Fragment>
  );
}

export default Tabs;
